import 'firebase/auth';

import firebase from 'firebase/app';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import AuthCallback from './helpers/AuthCallback';
import PrivateRoute from './helpers/PrivateRoute';
import { useStores } from './hooks/useStores';
import { UserRoles } from './types/shared';
import Home from './views/Home';
import Page404 from './views/Page404';
import PartyNotFound from './views/PartyNotFound';
import SignIn from './views/SignIn';
import SignInGuest from './views/SignInGuest';

function useStoreData() {
    const { store } = useStores();
    return {
        initPlayer: store.playback.initPlayer,
        setAuthRole: store.auth.setAuthRole,
        refreshSpotifyUserAccessToken: store.auth.refreshSpotifyUserAccessToken,
        refreshSpotifyAppAccessToken: store.auth.refreshSpotifyAppAccessToken,
    };
}

const App = () => {
    const { refreshSpotifyUserAccessToken, initPlayer, setAuthRole, refreshSpotifyAppAccessToken } = useStoreData();

    useEffect(() => {
        firebase.auth().onAuthStateChanged(async user => {
            console.log('user: ', user);
            if (!user) {
                return;
            }
            const idToken = await user.getIdTokenResult();
            if (idToken.claims.role === UserRoles.HOST) {
                console.log('HOST');
                setAuthRole(UserRoles.HOST);
                await refreshSpotifyUserAccessToken();
                await initPlayer();
                console.log('PLAYER INIT');
            } else {
                setAuthRole(UserRoles.GUEST);
                await refreshSpotifyAppAccessToken();
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Router>
            <Switch>
                <PrivateRoute exact path="/" requiredRoles={[UserRoles.HOST]}>
                    <Home />
                </PrivateRoute>
                <PrivateRoute exact path="/party/:userId/:playlistId" requiredRoles={[UserRoles.GUEST]}>
                    <Home />
                </PrivateRoute>
                <Route exact path="/signin-party">
                    <SignInGuest />
                </Route>
                <Route exact path="/auth/callback">
                    <AuthCallback />
                </Route>
                <Route exact path="/auth/callback-spotify-guest">
                    <AuthCallback />
                </Route>
                <Route exact path="/signin">
                    <SignIn />
                </Route>
                <Route path="/party-not-found">
                    <PartyNotFound />
                </Route>
                <Route path="*">
                    <Page404 />
                </Route>
            </Switch>
        </Router>
    );
};

export default App;
